interface AnyFunc {
    (...args: any[]): any;
}